// 组件
import importImg from '@/components/importImg.vue'
import alterForm from '@/components/alterForm'
// 接口
// import { postShopsFormData } from '@/services/store.js'
import * as shopsApi from '@/services/shops.js'
import * as bundleApi from '@/services/bundles.js'
import { getShopItemsSimpleList } from '@/services/promotion.js'
// 其他
import loading from '@/utils/loading.json'
import jsonData from './jsonData'
import constant from '@/utils/constant.js'

export default {
  components: {
    importImg,
    alterForm
  },
  data () {
    return {
      collapseLength: [],
      formData: jsonData.formData,
      urlParams: {},
      modifyData: {}
    }
  },
  watch: {
  },
  created () {
    this.urlParams = this.$route.params
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.collapseLength = [...new Array(this.formData.length).keys()]
      this.$store.state.app.loading = this.$loading(loading)
      bundleApi.getBundleEditDetail(this.urlParams.id).then((res) => {
        this.modifyData = res.data.shop_item_bundle
        this.handleChange(res.data.shop_item_bundle.shop_id)
      })
      shopsApi.getShopsSimpleList().then(res => {
        if (res.status === 200) {
          res.data.shops.forEach((item) => {
            const obj = {
              value: item.id,
              name: item.name
            }
            this.formData[0].createDateItem[2].options.push(obj)
          })
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    },
    handleChange (data) {
      const obj = {
        shop_id_eq: data,
        all: true,
        only_name: true
      }
      this.formData[0].createDateItem[10].createDateFirstItem[1].options = []
      getShopItemsSimpleList(obj).then((res) => {
        res.data.shop_items.forEach((item) => {
          const obj = {
            value: item.id,
            name: item.name
          }
          this.formData[0].createDateItem[10].createDateFirstItem[1].options.push(obj)
        })
      })
    },
    formSubmit (data) {
      console.log('-----data----', data)
      this.$store.state.app.loading = this.$loading(loading)
      const obj = JSON.parse(JSON.stringify(data))
      // const bundle_items_attributes = []
      // for (let i = 0; i < obj.bundle_items_attributes.length; i++) {
      //   obj.bundle_items_attributes[i].discount_percent = Number(obj.bundle_items_attributes[i].discount_percent)
      //   const item = obj.bundle_items_attributes[i]
      //   bundle_items_attributes.push(item)
      // }
      // obj.bundle_items_attributes = bundle_items_attributes
      // const { online, shop_id, name, name_en, start_date, end_date, short_description, short_description_en } = obj
      const params = obj
      bundleApi.editBundle(this.urlParams.id, params).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: this.$t('message.operateSuccess')
          })
          setTimeout(() => {
            this.$router.replace({
              name: 'bundleManagerList'
            })
          }, constant.ROUTER_CHANGE_INTERVAL)
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    }
  }
}
